module.exports = __webpack_public_path__ + "static/media/027-conversation.949be394.svg";